import { strCode } from "../localizations/strCode";

export const conversionTypes = {
  all: "all",
  conversion: "conversion",
  nonConversion: "non-conversion"
};

export const conversionTypeOptions = [
  { id: conversionTypes.all, value: strCode.ALL_CONVERSION_TYPES },
  {
    id: conversionTypes.conversion,
    value: strCode.CONVERSION_TITLE
  },
  {
    id: conversionTypes.nonConversion,
    value: strCode.NON_CONVERSION_TITLE
  }
];
